import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from "./utility/ProtectedRoute";

import NotFound from "./pages/NotFound";
import NotAuthorised from "./pages/UnauthorizedPage";

// Auths
import RestaurantAuth from "./pages/RestaurantPOS/Restaurant_LoginPage";  
import Central_LoginPage from "./pages/RestaurantPOS/Central_LoginPage"; 
import ICT_LoginPage from "./pages/ICT/Ict_LoginPage"; 


// Restaurant/Lounge  Waiters
import AficanWaitersDashboard from "./pages/RestaurantPOS/waiters/Afican_Waiters/Afican_WaitersDashboard";
import Continental_WaitersDashboard from "./pages/RestaurantPOS/waiters/Continental_Waiters/Continental_WaitersDashboard";
import Lounge_WaitersDashboard from "./pages/RestaurantPOS/waiters/Lounge_Waiters/Lounge_WaitersDashboard";

import AfricanTablesAndOrdersDashboard from "./pages/RestaurantPOS/waiters/Afican_Waiters/AfricanTablesAndOrdersDashboard";
import ContinentalTablesAndOrdersDashboard from "./pages/RestaurantPOS/waiters/Continental_Waiters/ContinentalTablesAndOrdersDashboard";
import LoungeTablesAndOrdersDashboard from "./pages/RestaurantPOS/waiters/Lounge_Waiters/LoungeTablesAndOrdersDashboard";

import AfricanOrderHistory from "./pages/RestaurantPOS/waiters/Afican_Waiters/AfricanOrderHistory";
import ContinentalOrderHistory from "./pages/RestaurantPOS/waiters/Continental_Waiters/ContinentalOrderHistory";
import LoungeOrderHistory from "./pages/RestaurantPOS/waiters/Lounge_Waiters/LoungeOrderHistory";


// Restaurant/Lounge  cashier
import AfricanCashierDashboard from "./pages/RestaurantPOS/cashier/Afican_Cashier/AfricanCashierDashboard";
import ContinentalCashierDashboard from "./pages/RestaurantPOS/cashier/Continental_Cashier/ContinentalCashierDashboard";
import LoungeCashierDashboard from "./pages/RestaurantPOS/cashier/Lounge_Cashier/LoungeCashierDashboard";


import AfricanEOD from "./pages/RestaurantPOS/cashier/Afican_Cashier/AfricanEOD";
import ContinentalEOD from "./pages/RestaurantPOS/cashier/Continental_Cashier/ContinentalEOD";
import LoungeEOD from "./pages/RestaurantPOS/cashier/Lounge_Cashier/LoungeEOD";

import AfricanSalesSummary from "./pages/RestaurantPOS/cashier/Afican_Cashier/AfricanSalesSummary";
import ContinentalSalesSummary from "./pages/RestaurantPOS/cashier/Continental_Cashier/ContinentalSalesSummary";
import LoungeSalesSummary from "./pages/RestaurantPOS/cashier/Lounge_Cashier/LoungeSalesSummary";


//Africa Manager 
import ManagerDashboard_A from "./pages/RestaurantPOS/manager/ManagerDashboard_A";
import AfricanTables from "./pages/RestaurantPOS/manager/African/AfricanTables";
import AfricanCategories from "./pages/RestaurantPOS/manager/African/AfricanCategories";
import AfricanMenuItems from "./pages/RestaurantPOS/manager/African/AfricanMenuItems";

import AfricanDiscountManager from "./pages/RestaurantPOS/manager/African/AfricanDiscountManager";
import ContinentalDiscountManager from "./pages/RestaurantPOS/manager/Continental/ContinentalDiscountManager";
import LoungeDiscountManager from "./pages/RestaurantPOS/manager/Lounge/LoungeDiscountManager";
import AfricanInventory from "./pages/RestaurantPOS/manager/African/AfricanInventory";
 

//Manager Continental
import ManagerDashboard_C from "./pages/RestaurantPOS/manager/ManagerDashboard_C";
import ContinentalTables from "./pages/RestaurantPOS/manager/Continental/ContinentalTables";
import ContinentalCategories from "./pages/RestaurantPOS/manager/Continental/ContinentalCategories";
import ContinentalMenuItems from "./pages/RestaurantPOS/manager/Continental/ContinentalMenuItems";
import ContinentalInventory from "./pages/RestaurantPOS/manager/Continental/ContinentalInventory";
 
//Manager Lounge
import ManagerDashboard_L from "./pages/RestaurantPOS/manager/ManagerDashboard_L";
import LoungeTables from "./pages/RestaurantPOS/manager/Lounge/LoungeTables";
import LoungeCategories from "./pages/RestaurantPOS/manager/Lounge/LoungeCategories";
import LoungeMenuItems from "./pages/RestaurantPOS/manager/Lounge/LoungeMenuItems";
import LoungeInventory from "./pages/RestaurantPOS/manager/Lounge/LoungeInventory";

//Lounge Consultants
import ManagerDashboard_L_consultants from "./pages/RestaurantPOS/manager/Lounge_consultants/ManagerDashboard_L";
import LoungeTables_consultants from "./pages/RestaurantPOS/manager/Lounge_consultants/LoungeTables";
import LoungeMenuItems_consultants from "./pages/RestaurantPOS/manager/Lounge_consultants/LoungeMenuItems";


//Account
import Account_LoginPage from "./pages/Account/Account_LoginPage";
import Dashboard_Accountant from "./pages/Account/Dashboard_Accountant";
import AfricanTransactionDetails from "./pages/Account/Restaurant_and_lounge/African/AfricanTransactionDetails";
import ContinentalTransactionDetails from "./pages/Account/Restaurant_and_lounge/Continental/ContinentalTransactionDetails";
import LoungeTransactionDetails from "./pages/Account/Restaurant_and_lounge/Lounge/LoungeTransactionDetails";

import LoungeInventory_AfricanInventory from "./pages/Account/Restaurant_and_lounge/African/AfricanInventory";
import ContinentalInventory_Acc from "./pages/Account/Restaurant_and_lounge/Continental/ContinentalInventory";
import LoungeInventory_Acc from "./pages/Account/Restaurant_and_lounge/Lounge/LoungeInventory";

//ICT
import Dashboard_ict from "./pages/ICT/Dashboard_ict";
import UserManagement from "./pages/ICT/UserManagement";


function App() {
  return (
    <Router>
      <Routes>



        {/* Auths Route */}
        <Route path="/RestaurantAuth" element={<RestaurantAuth />} />  
           <Route path="/Account_LoginPage" element={<Account_LoginPage />} />  

  <Route path="/ICT_LoginPage" element={<ICT_LoginPage />} />  

        <Route path="/Central_LoginPage" element={<Central_LoginPage />} />  




         {/*Restaurant/Lounge Waiters*/}
        <Route path="/restaurant/african" element={<ProtectedRoute allowedRoles={['waiter']}> <AficanWaitersDashboard /> </ProtectedRoute>} />
        <Route path="/restaurant/continental" element={<ProtectedRoute allowedRoles={['waiter']}> <Continental_WaitersDashboard /> </ProtectedRoute>} />
        <Route path="/waiter/lounge" element={<ProtectedRoute allowedRoles={['waiter']}> <Lounge_WaitersDashboard /> </ProtectedRoute>} />

         <Route path="/waiter/AfricanTablesAndOrdersDashboard" element={<ProtectedRoute allowedRoles={['waiter']}> <AfricanTablesAndOrdersDashboard /> </ProtectedRoute>} />
          <Route path="/waiter/ContinentalTablesAndOrdersDashboard" element={<ProtectedRoute allowedRoles={['waiter']}> <ContinentalTablesAndOrdersDashboard /> </ProtectedRoute>} />
           <Route path="/waiter/LoungeTablesAndOrdersDashboard" element={<ProtectedRoute allowedRoles={['waiter']}> <LoungeTablesAndOrdersDashboard /> </ProtectedRoute>} />

           <Route path="/waiter/AfricanOrderHistory" element={<ProtectedRoute allowedRoles={['waiter']}> <AfricanOrderHistory /> </ProtectedRoute>} />
              <Route path="/waiter/ContinentalOrderHistory" element={<ProtectedRoute allowedRoles={['waiter']}> <ContinentalOrderHistory /> </ProtectedRoute>} />
            <Route path="/waiter/LoungeOrderHistory" element={<ProtectedRoute allowedRoles={['waiter']}> <LoungeOrderHistory /> </ProtectedRoute>} />


{/*Restaurant/Lounge cashier*/}
 <Route path="/restaurant/AfricanCashierDashboard" element={<ProtectedRoute allowedRoles={['cashier']}> <AfricanCashierDashboard /> </ProtectedRoute>} />
  <Route path="/restaurant/ContinentalCashierDashboard" element={<ProtectedRoute allowedRoles={['cashier']}> <ContinentalCashierDashboard /> </ProtectedRoute>} />
<Route path="/restaurant/LoungeCashierDashboard" element={<ProtectedRoute allowedRoles={['cashier']}> <LoungeCashierDashboard /> </ProtectedRoute>} />
 

 <Route path="/cashier/AfricanEOD" element={<ProtectedRoute allowedRoles={['cashier']}> <AfricanEOD /> </ProtectedRoute>} />
<Route path="/cashier/ContinentalEOD" element={<ProtectedRoute allowedRoles={['cashier']}> <ContinentalEOD /> </ProtectedRoute>} />
<Route path="/cashier/LoungeEOD" element={<ProtectedRoute allowedRoles={['cashier']}> <LoungeEOD /> </ProtectedRoute>} />


 <Route path="/cashier/AfricanSalesSummary" element={<ProtectedRoute allowedRoles={['cashier']}> <AfricanSalesSummary /> </ProtectedRoute>} />
<Route path="/cashier/ContinentalSalesSummary" element={<ProtectedRoute allowedRoles={['cashier']}> <ContinentalSalesSummary /> </ProtectedRoute>} />
<Route path="/cashier/LoungeSalesSummary" element={<ProtectedRoute allowedRoles={['cashier']}> <LoungeSalesSummary /> </ProtectedRoute>} />

{/* Africa */}

         <Route path="/ManagerDashboard_A" element={<ProtectedRoute allowedRoles={['manager']}> <ManagerDashboard_A /> </ProtectedRoute>} />
       <Route path="/AfricanTables" element={<ProtectedRoute allowedRoles={['manager']}> <AfricanTables /> </ProtectedRoute>} />
     <Route path="/menu/categories" element={<ProtectedRoute allowedRoles={['manager']}> <AfricanCategories /> </ProtectedRoute>} />
     <Route path="/menu/AfricanMenuItems" element={<ProtectedRoute allowedRoles={['manager']}> <AfricanMenuItems /> </ProtectedRoute>} />
    <Route path="/African/AfricanDiscountManager" element={<ProtectedRoute allowedRoles={['manager']}> <AfricanDiscountManager /> </ProtectedRoute>} />
  <Route path="/Continental/ContinentalDiscountManager" element={<ProtectedRoute allowedRoles={['manager']}> <ContinentalDiscountManager /> </ProtectedRoute>} />
 <Route path="/Lounge/LoungeDiscountManager" element={<ProtectedRoute allowedRoles={['manager']}> <LoungeDiscountManager /> </ProtectedRoute>} />
 
 <Route path="/inventory/african" element={<ProtectedRoute allowedRoles={['manager']}> <AfricanInventory /> </ProtectedRoute>} />
 
    
     {/* Continental  */}
      
      
       <Route path="/ManagerDashboard_C" element={<ProtectedRoute allowedRoles={['manager']}> <ManagerDashboard_C /> </ProtectedRoute>} />
        <Route path="/ContinentalTables" element={<ProtectedRoute allowedRoles={['manager']}> <ContinentalTables /> </ProtectedRoute>} />
        <Route path="/menu/ContinentalCategories" element={<ProtectedRoute allowedRoles={['manager']}> <ContinentalCategories /> </ProtectedRoute>} />
     <Route path="/menu/ContinentalMenuItems" element={<ProtectedRoute allowedRoles={['manager']}> <ContinentalMenuItems /> </ProtectedRoute>} />
   <Route path="/inventory/Continental" element={<ProtectedRoute allowedRoles={['manager']}> <ContinentalInventory /> </ProtectedRoute>} />
 
    
       
        {/* Lounge */}
        <Route path="/ManagerDashboard_L" element={<ProtectedRoute allowedRoles={['manager']}> <ManagerDashboard_L /> </ProtectedRoute>} />
        <Route path="/LoungeTables" element={<ProtectedRoute allowedRoles={['manager']}> <LoungeTables /> </ProtectedRoute>} />
        <Route path="/menu/LoungeCategories" element={<ProtectedRoute allowedRoles={['manager']}> <LoungeCategories /> </ProtectedRoute>} />
        <Route path="/menu/LoungeMenuItems" element={<ProtectedRoute allowedRoles={['manager']}> <LoungeMenuItems /> </ProtectedRoute>} />
       <Route path="/inventory/Lounge" element={<ProtectedRoute allowedRoles={['manager']}> <LoungeInventory /> </ProtectedRoute>} />
      
       {/* Lounge Consultants */}
        <Route path="/ManagerDashboard_L_consultz" element={<ProtectedRoute allowedRoles={['Lounge_Managers']}> <ManagerDashboard_L_consultants /> </ProtectedRoute>} />
      <Route path="/Lounge/Tables/consultz" element={<ProtectedRoute allowedRoles={['Lounge_Managers']}> <LoungeTables_consultants /> </ProtectedRoute>} />
       <Route path="Lounge/MenuItems/consultants" element={<ProtectedRoute allowedRoles={['Lounge_Managers']}> <LoungeMenuItems_consultants /> </ProtectedRoute>} />
     
      
       {/* ACCOUNT */}
<Route path="/Dashboard/Accountant" element={<ProtectedRoute allowedRoles={['account']}> <Dashboard_Accountant /> </ProtectedRoute>} />
<Route path="/Account/AfricanTransactionDetails" element={<ProtectedRoute allowedRoles={['account']}> <AfricanTransactionDetails /> </ProtectedRoute>} />
<Route path="/Account/ContinentalTransactionDetails" element={<ProtectedRoute allowedRoles={['account']}> <ContinentalTransactionDetails /> </ProtectedRoute>} />
<Route path="/Account/LoungeTransactionDetails" element={<ProtectedRoute allowedRoles={['account']}> <LoungeTransactionDetails /> </ProtectedRoute>} />

 <Route path="/inventory/acc/african" element={<ProtectedRoute allowedRoles={['account']}> <LoungeInventory_AfricanInventory /> </ProtectedRoute>} />
  <Route path="/inventory/acc/continental" element={<ProtectedRoute allowedRoles={['account']}> <ContinentalInventory_Acc /> </ProtectedRoute>} />
   <Route path="/inventory/acc/lounge" element={<ProtectedRoute allowedRoles={['account']}> <LoungeInventory_Acc /> </ProtectedRoute>} />
  
     
{/* ICT */}
  <Route path="/Dashboard/Ict" element={<ProtectedRoute allowedRoles={['ict']}> <Dashboard_ict /> </ProtectedRoute>} />
  <Route path="/system/users" element={<ProtectedRoute allowedRoles={['ict']}> <UserManagement /> </ProtectedRoute>} />
  

        {/* 404 - Catch all unmatched routes */}
        <Route path="*" element={<NotFound />} />      
         
         <Route path="/" element={<Central_LoginPage />} />      
      
         

      </Routes>
    </Router>
  );
}

export default App;
